// vuex 本地存储
import saveInLocal from "../plugin/saveInLocal.js" //导入配置文件
export default { //导出
    state: { //状态数据
        TOAST_INFO: '您的企业微信账号没有访问Tickos应用的权限，无法登录Tickos应用系统，请联系企业微信管理员！',
        TOAST_500_INFO: '',
        token: ''
    },
    mutations: {
        SET_TOAST(state, TOAST_INFO) {
            state.TOAST_INFO = TOAST_INFO
        },
        SET_TOKEN(state, TOKEN) {
            state.token = TOKEN
        },
        SET_500_TOAST(state, TOAST_500_INFO) {
            state.TOAST_500_INFO = TOAST_500_INFO
        },
    },
    actions: {

    },
    plugins: [saveInLocal], //配置文件
}